module.exports = __webpack_public_path__ + "static/media/pimienta-limon.a9f09e7c.png";